const RECAPTCHA_SITE_KEY_PROD = '6LfOcIYhAAAAADBS5OnBllme06dW9vyW4Zgowiru';
const RECAPTCHA_SITE_KEY_STAGING = '6LebaYYhAAAAAKFQt-KH6vVkTJQqwZddT-HJCIM3';
const RECAPTCHA_SITE_KEY_DEV = '6Le_DxYiAAAAABV8BsFSj3AmZf3OkP9Fh9lfbZOZ';

const DEV_ENV_HOSTNAMES = [
	'localhost',
	'127.0.0.1',
	'0.0.0.0',
	'statlas.atl-paas.net',
	'atlaskit.atlassian.com',
];

const isProd = (): boolean => (window.location.host.includes('-dev.com') ? false : true);

const isDevEnv = () => DEV_ENV_HOSTNAMES.includes(window.location.hostname);

export const getRecaptchaSiteKey = () =>
	isDevEnv()
		? RECAPTCHA_SITE_KEY_DEV
		: isProd()
			? RECAPTCHA_SITE_KEY_PROD
			: RECAPTCHA_SITE_KEY_STAGING;
